import React from 'react';
import WordCloud from 'react-d3-cloud';

const MissedQuestionsWordCloud = ({ missedKcs, subtopicIdToNameMap }) => {
	// Prepare words array with text, value, and color
	const words = missedKcs.map((item) => ({
		text: subtopicIdToNameMap[item.subtopicId] || 'Unknown',
		value: item.incorrectAnswers,
		color: item.color || 'white',
	}));

	// Min-max normalize value to font size range
	const minVal = Math.min(...words.map((w) => w.value));
	const maxVal = Math.max(...words.map((w) => w.value));

	// Increase minFont and maxFont values for better visibility
	const minFont = 30; // Previously 20
	const maxFont = 100; // Previously 80

	const fontSizeMapper = (word) => {
		if (minVal === maxVal) return (minFont + maxFont) / 2;
		return ((word.value - minVal) / (maxVal - minVal)) * (maxFont - minFont) + minFont;
	};

	// Custom fill color function
	const customFill = (word) => word.color;

	return (
		<div style={{ width: '100%', height: '400px' }}>
			<WordCloud
				data={words}
				fontSizeMapper={fontSizeMapper}
				width={100}
				height={50}
				padding={3}
				rotate={0}
				spiral="archimedean"
				font="sans-serif"
				fontWeight="bold"
				fill={customFill}
			/>
		</div>
	);
};

export default MissedQuestionsWordCloud;
